import { partesDaRoda } from './partesDaRoda'

/**
 * Roda de liga. O conjunto rolante vai fundido por material (ver `partesDaRoda`):
 * são 7 malhas no lugar de 15, com a mesma geometria e os mesmos materiais, e as
 * quatro rodas de um veículo dividem os mesmos objetos.
 *
 * Eixo Y local; a face externa está em Y negativo.
 */
export function RodaLiga3D({ raio, largura, simplificada = false, giro = 0 }: { raio: number; largura: number; simplificada?: boolean; giro?: number }) {
  const aro = raio * 0.68
  return <group name="roda-liga-vazada">
    <group name="conjunto-rolante" rotation={[0, giro, 0]}>
      {partesDaRoda(raio, largura, simplificada).map((parte) => (
        <mesh key={parte.chave} geometry={parte.geometria} material={parte.material} />
      ))}
    </group>
    {!simplificada && <mesh name="pinca-freio-fixa" position={[aro * 0.62, -largura * 0.2, 0]}><boxGeometry args={[aro * 0.3, 0.035, aro * 0.45]} /><meshStandardMaterial color="#b56340" metalness={0.4} roughness={0.5} /></mesh>
    }
  </group>
}
